export default __webpack_public_path__ + "static/media/pastel.a6966948.jpg";